import * as actionTypes from "../actions/accounts/actionTypes";
import { ucUserCreate } from "../config/config";

const newAccount = (
  state = {
    accountFields: {},
    createAccountFailed: false,
    createAccountFailedMessage: "",
    submitSucceeded: false,
    submittingForm: false,
    system: ucUserCreate.system
  },
  action
) => {
  switch (action.type) {
    case actionTypes.CREATE_ACCOUNT:
      return Object.assign({}, state, {
        accountFields: action.accountFields
      });
    case actionTypes.SUBMITTING_ACCOUNT:
      return Object.assign({}, state, {
        submittingForm: true,
        submitSucceeded: false,
        createAccountFailed: false,
        createAccountFailedMessage: ""
      });
    case actionTypes.SUBMIT_SUCCEEDED:
      return Object.assign({}, state, {
        submittingForm: false,
        submitSucceeded: true,
        createAccountFailed: false,
        createAccountFailedMessage: ""
      });
    case actionTypes.CREATE_ACCOUNT_FAILED:
      return Object.assign({}, state, {
        submittingForm: false,
        submitSucceeded: false,
        createAccountFailed: true,
        createAccountFailedMessage: action.payload.message
      });
    default:
      return state;
  }
};

export default newAccount;
